import { t } from "i18next";
import { getWorkspaceSettingValue, workspaceSettingDefaults } from "src/services/appSettingsService/appSettingsService";

export const workspacePageSettingNames: API.WorkspaceSettingName[] = [
    "EnrollmentPageEnabled",
    "OverviewPageEnabled",
    "DevicesPageEnabled",
    "GroupsPageEnabled",
    "ProvisioningPageEnabled",
    "DownloadsPageEnabled",
    "ProductsPageEnabled",
    "FilesPageEnabled",
    "RolloutPageEnabled",
];

export const workspaceFeatureSettingNames: API.WorkspaceSettingName[] = [
    "OverviewPageShowsActivityChart",
    "DownloadsPageShowsPublicProducts",
    "MembersRequireTwoFactorAuthentication",
];

export function buildWorkspaceSettingsState(settingsList: readonly API.WorkspaceSetting[]) {
    const valueByName = {} as Record<API.WorkspaceSettingName, 0 | 1>;
    for (const name of Object.keys(workspaceSettingDefaults) as API.WorkspaceSettingName[]) {
        valueByName[name] = getWorkspaceSettingValue(settingsList, name) ? 1 : 0;
    }
    return { valueByName };
}

const workspaceSettingLabels: Record<API.WorkspaceSettingName, { title: string; description: string }> = {
    DevicesPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.DevicesPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.DevicesPageEnabled.description"),
    },
    EnrollmentPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.EnrollmentPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.EnrollmentPageEnabled.description"),
    },
    DownloadsPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.DownloadsPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.DownloadsPageEnabled.description"),
    },
    DownloadsPageShowsPublicProducts: {
        title: t("pages:workspacePage.configuration.settings.DownloadsPageShowsPublicProducts.title"),
        description: t("pages:workspacePage.configuration.settings.DownloadsPageShowsPublicProducts.description"),
    },
    FilesPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.FilesPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.FilesPageEnabled.description"),
    },
    GroupsPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.GroupsPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.GroupsPageEnabled.description"),
    },
    MembersRequireTwoFactorAuthentication: {
        title: t("pages:workspacePage.configuration.settings.MembersRequireTwoFactorAuthentication.title"),
        description: t("pages:workspacePage.configuration.settings.MembersRequireTwoFactorAuthentication.description"),
    },
    OverviewPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.OverviewPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.OverviewPageEnabled.description"),
    },
    OverviewPageShowsActivityChart: {
        title: t("pages:workspacePage.configuration.settings.OverviewPageShowsActivityChart.title"),
        description: t("pages:workspacePage.configuration.settings.OverviewPageShowsActivityChart.description"),
    },
    ProductsPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.ProductsPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.ProductsPageEnabled.description"),
    },
    ProvisioningPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.ProvisioningPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.ProvisioningPageEnabled.description"),
    },
    RolloutPageEnabled: {
        title: t("pages:workspacePage.configuration.settings.RolloutPageEnabled.title"),
        description: t("pages:workspacePage.configuration.settings.RolloutPageEnabled.description"),
    },
};

export function getWorkspaceSettingLabels(name: API.WorkspaceSettingName) {
    return workspaceSettingLabels[name];
}
